// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors@bb-app-layer@bb-global@bb-template.blog@bb-template.cart@bb-template.collection@bb-template.page@bb-template.product","vendors@bb-app-layer@bb-global@bb-template.cart@bb-template.product"], () => (__webpack_require__("./src/scripts/template/cart.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
